"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscreteSampleAggregator = void 0;
var ESTIMATOR_MAX_SAMPLE_COUNT = 20;
var ESTIMATOR_MAX_SAMPLE_AGE_MS = 1000 * 20; // 20 seconds
var DiscreteSampleAggregator = /** @class */ (function () {
    function DiscreteSampleAggregator(logger, name, getDynamicMaxSampleAgeMs, _a) {
        var _b = _a === void 0 ? {} : _a, maxSampleCount = _b.maxSampleCount, maxSampleAgeMs = _b.maxSampleAgeMs, useDynamicMaxSampleAge = _b.useDynamicMaxSampleAge;
        this.getDynamicMaxSampleAgeMs = getDynamicMaxSampleAgeMs;
        this.samples = [];
        this.logger = logger.withContext(name);
        this.maxSampleCount = maxSampleCount !== null && maxSampleCount !== void 0 ? maxSampleCount : ESTIMATOR_MAX_SAMPLE_COUNT;
        this.maxSampleAgeMs = maxSampleAgeMs !== null && maxSampleAgeMs !== void 0 ? maxSampleAgeMs : ESTIMATOR_MAX_SAMPLE_AGE_MS;
        this.useDynamicMaxSampleAge = !!useDynamicMaxSampleAge;
        this.logger.info("".concat(name, ", using max sample count: ").concat(this.maxSampleCount));
    }
    DiscreteSampleAggregator.prototype.sample = function (newSample) {
        this.samples.push(newSample);
        var maxSampleAgeMs = this.maxSampleAgeMs;
        if (this.useDynamicMaxSampleAge && this.getDynamicMaxSampleAgeMs) {
            maxSampleAgeMs = this.getDynamicMaxSampleAgeMs(this.maxSampleAgeMs);
        }
        var now = Date.now();
        this.logger.verbose('maxSampleAgeMs used: ', maxSampleAgeMs);
        this.samples = this.samples.filter(function (s) {
            return s.timeRecorded > now - maxSampleAgeMs;
        });
        if (this.maxSampleCount) {
            this.samples = this.samples.slice(-this.maxSampleCount);
        }
    };
    DiscreteSampleAggregator.prototype.clear = function () {
        this.samples = [];
    };
    return DiscreteSampleAggregator;
}());
exports.DiscreteSampleAggregator = DiscreteSampleAggregator;
